// Mirror of QuantityChangePreview in server/domains/quantityChange/quantityChangeService.ts.
export type QuantityInfoValue = { stdAmount: number; stdMultiplier: number; stdUnit: string; weightString?: string };
export type QuantityChangePreview = {
  fingerprint: string;
  restaurantId: string;
  productName: string;
  reset: boolean;
  from: QuantityInfoValue | null;
  to: QuantityInfoValue | null;
  recipes: Array<{ name: string; kind: 'analysis' | 'subrecipe'; dishAmount: boolean; from: number; fromUnit: string; to: number; toUnit: string }>;
  sections: Array<{ label: string; from: Array<{ unit: string; factor: number; stdUnit: unknown }>; to: Array<{ unit: string; factor: number; stdUnit: string }> }>;
  pastCounts: { lines: number; counts: number; valueBefore: number; valueAfter: number } | null;
  minimum: { count: number; countUnit: string; fromStd: number; toStd: number; toUnit: string } | null;
  priceOverride: { from: number; fromUnit: unknown; to: number; toUnit: string } | null;
  toCheck: Array<{ name: string; kind: 'recipe' | 'section' | 'past_count' | 'minimum' | 'no_pack' }>;
  renameLabels: Array<{ unit: string; label: string }>;
  assumesWholePacks: boolean;
  /** Ambiguous identity: this preview cannot be applied. */
  notConverted: boolean;
};
export type QuantityChangeTarget = { stdAmount: number; stdMultiplier: number; stdUnit: string; weightString: string };
/** The server refuses a change whose preview no longer matches what it would do. */
export class QuantityChangeStaleError extends Error {}
